import DatasetLineChart from "components/dashboard/charts/dataset-line-chart/DatasetLineChart";
import { DatasetSpecification } from "components/dashboard/charts/interfaces";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";

interface ChartInDialogButtonProps {
  dataset?: DatasetSpecification;
  identifier: string;
  dateFrom?: Date;
  dateTo?: Date;
  header?: string;
  setIsDialogOpen?: (value: boolean) => void;
}

const ChartInDialogButton = ({
  dateFrom,
  dateTo,
  dataset,
  identifier,
  header,
  setIsDialogOpen,
}: ChartInDialogButtonProps) => {
  const [isDialogVisible, setDialogVisibility] = useState(false);
  useEffect(() => {
    if (isDialogVisible && setIsDialogOpen) {
      setIsDialogOpen(true);
    }
  }, [isDialogVisible]);

  return (
    <>
      <i
        className="pi pi-chart-line"
        onClick={() => {
          setDialogVisibility(true);
        }}
        style={{ cursor: "pointer" }}
      />
      <Dialog
        header={header ? header : "Chart"}
        onHide={() => {
          setDialogVisibility(false);
        }}
        visible={isDialogVisible}
        style={{ width: "min(100vw, 1000px)", height: "500px" }}
        modal={false}
        resizable={true}
        draggable={true}
        maximizable
      >
        <DatasetLineChart
          dateFrom={dateFrom}
          dateTo={dateTo}
          identifiers={[identifier]}
          dynamicHeight
          showDateSelection={true}
          chartDialogOpen={isDialogVisible}
        />
      </Dialog>
    </>
  );
};

export default ChartInDialogButton;
